// extracted by mini-css-extract-plugin
export default {"container":"ActivityOffersList_container__EW1aV"};